import {Directive, ElementRef, OnInit} from '@angular/core';

@Directive({
  selector: '[appSelect]'
})
export class SelectDirective implements OnInit {

  constructor(private element: ElementRef) {
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.element && this.element.nativeElement && this.element.nativeElement.focus)
        this.element.nativeElement.select();
    });
  }
}
